var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTokenvariableIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.232,
    height: 15.589,
    viewBox: "0 0 17.232 15.589",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#444;stroke-linecap:round;stroke-linejoin:round;stroke-width:.8px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    "data-name": "Group 1255",
    transform: "translate(-677.669 -731.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107",
    transform: "translate(678.069 731.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20640",
    "data-name": "Path 20640",
    className: "cls-1",
    d: "M697.8 733.63a.586.586 0 0 0-.59-.653h-1.833a1.375 1.375 0 0 0-1.32 1.345s.009 4.317 0 4.338c0 1.383-1.714 1.505-1.714 1.746s1.714.436 1.714 1.746c.006.026 0 4.279 0 4.279s.2 1.294 1.406 1.294l1.806.041a.7.7 0 0 0 .532-.642",
    transform: "translate(-692.344 -732.977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20641",
    "data-name": "Path 20641",
    className: "cls-1",
    d: "M692.344 733.63a.586.586 0 0 1 .59-.653h1.833a1.375 1.375 0 0 1 1.32 1.345s-.009 4.317 0 4.338c0 1.383 1.714 1.505 1.714 1.746s-1.714.436-1.714 1.746c-.006.026 0 4.279 0 4.279s-.2 1.294-1.406 1.294l-1.806.041a.7.7 0 0 1-.532-.642",
    transform: "translate(-681.369 -732.976)"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTokenvariableIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tokenvariableIcon.623ca8d2.svg";
export { ForwardRef as ReactComponent };